// External libraries
import styled from '@emotion/styled';

// Internal modules
import {
  ADDRESS_MARGIN_BOTTOM_PP,
  bodyStyles,
  FONT_SIZE_SMALL,
  FONT_WEIGHT_NORMAL_PP,
  HEADER_COLOR,
  HIGH_CONTRAST_TEXT_COLOR,
  TEXT_COLOR,
} from '@/styles';

const AccountFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;

  > div:not(:last-child) {
    margin-bottom: ${ADDRESS_MARGIN_BOTTOM_PP};
  }
`;

const AddressLoadingContainer = styled.div`
  margin-bottom: 16px;

  @media (min-width: 365px) {
    margin-bottom: ${ADDRESS_MARGIN_BOTTOM_PP};
  }

  > div:not(:last-child) {
    margin-bottom: ${ADDRESS_MARGIN_BOTTOM_PP};
  }
`;

const marginY = {
  gutter: '12px',
  lg: '20px',
  mb: '16px',
  md: '18px',
};

export type MarginY = keyof typeof marginY;

const marginBottom = ({ mb }: { mb?: MarginY }) => {
  return mb ? marginY[mb] : marginY.md;
};

const Section = styled.section<{ mb?: MarginY }>`
  margin-bottom: ${marginBottom};

  > div:not(:last-child) {
    margin-bottom: ${ADDRESS_MARGIN_BOTTOM_PP};
  }
`;

const SignupValueProp = styled.p`
  font-size: 15px;
  font-weight: normal;
  line-height: 1.6;
  margin-bottom: 18px;

  .overrides-font-4-2 & {
    ${bodyStyles}
  }
`;

const SignupValuePropBold = styled(SignupValueProp)`
  font-weight: bold;
`;

const CobrandedDisclaimerContainer = styled.p`
  color: ${TEXT_COLOR};
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  margin: 0 5px 16px;
`;

const OvercaptureDisclaimerMessage = styled.p`
  align-items: center;
  color: ${HEADER_COLOR};
  font-size: 13px;
  line-height: 20px;
  margin: 19px 0;
`;

const CTADisclaimerMessage = styled.p`
  color: ${HIGH_CONTRAST_TEXT_COLOR};
  font-size: ${FONT_SIZE_SMALL};
  font-weight: ${FONT_WEIGHT_NORMAL_PP};
  line-height: 20px;
  margin: 32px 0 12px;
  text-align: center;
`;

const FormContainer = styled.div`
  position: relative;
`;

const StreamlineSectionTitle = styled.p`
  color: ${HEADER_COLOR};
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 24px;
  text-align: center;
`;

export {
  AccountFieldsContainer,
  AddressLoadingContainer,
  CobrandedDisclaimerContainer,
  Section,
  SignupValueProp,
  SignupValuePropBold,
  StreamlineSectionTitle,
  CTADisclaimerMessage,
  OvercaptureDisclaimerMessage,
  FormContainer,
};
